export default {
    USER_ID: 'user_smm16GXmbKc35UBzhTY6L',
    CONTACT_TEMPLATE_ID: 'contact_form',
    PRO_TEMPLATE_ID: 'estimate_form',
    SERVICE_ID: 'contact_service',
    CAPTCHA_SITE_KEY: '6LcnUr8bAAAAANnZ6FK8mPUHX4sAF5GZIzfkX1ej',
    GMAIL_PWD: 'uOuvkRCFGl!MOBGka,JM',
}